import type { ReactNode } from "react";
import { Container, Grid, Typography, useMediaQuery } from "@mui/material";
import CategorieTabs from "components/organisms/CategorieTabs";
import PageTitle from "components/molecules/PageTitle";
import { Outlet } from "react-router";
import { CatalogueProvider } from "providers";
import MetierInput from "components/atoms/inputs/MetierInput";

function CataloguePage(): ReactNode {
  const isLargeScreen = useMediaQuery((theme) => theme.breakpoints.down("xl"));

  return (
    <CatalogueProvider>
      <PageTitle noBackButton title="Catalogue">
        <Grid
          container
          size={{ xs: 12, sm: "grow" }}
          sx={{ justifyContent: "flex-end", alignItems: "center" }}
          spacing={1}>
          <Typography variant="caption">Filtrer pour mon métier :</Typography>
          <MetierInput />
        </Grid>
      </PageTitle>
      <Container maxWidth={isLargeScreen ? "lg" : "xl"} sx={{ xs: { p: 0, m: 0 } }}>
        <CategorieTabs />
      </Container>
      <Outlet />
    </CatalogueProvider>
  );
}

export default CataloguePage;
